module.exports = __webpack_public_path__ + "static/media/check-selected.be965281.svg";